import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _someInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/some';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import { nativeTypesConfig } from './d3b375455918d9de57984de626ce4fef5fcf40e562abfe28d1d96b22c3768a82.cfe-internal.js';
import { NativeDragSource } from './933116130f7a2a1c42cb5e3404350f3466af75159ca9f3a97a4613ea1fe95b0b.cfe-internal.js';

function createNativeDragSource(type, dataTransfer) {
  var config = nativeTypesConfig[type];
  if (!config) {
    throw new Error("native type ".concat(type, " has no configuration"));
  }
  var result = new NativeDragSource(config);
  result.loadDataTransfer(dataTransfer);
  return result;
}
function matchNativeItemType(dataTransfer) {
  var _context;
  if (!dataTransfer) {
    return null;
  }
  var dataTransferTypes = _sliceInstanceProperty(Array.prototype).call(dataTransfer.types || []);
  return _filterInstanceProperty(_context = _Object$keys(nativeTypesConfig)).call(_context, function (nativeItemType) {
    var _context2;
    var typeConfig = nativeTypesConfig[nativeItemType];
    if (!(typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.matchesTypes)) {
      return false;
    }
    return _someInstanceProperty(_context2 = typeConfig.matchesTypes).call(_context2, function (t) {
      return _indexOfInstanceProperty(dataTransferTypes).call(dataTransferTypes, t) > -1;
    });
  })[0] || null;
}

export { createNativeDragSource, matchNativeItemType };
